import e from "react";
import { c as u } from "./index-Di82Y7n3.js";
import { n as p } from "./normalize-spacing-DY0KSpr_.js";
import { c as f } from "./utils-BdNIfrGQ.js";
const m = u("cursor-pointer w-fit inline-flex items-center justify-center", {
  variants: {
    variant: {
      default: "text-md hover:underline underline-offset-4",
      nav: "text-base hover:underline underline-offset-4",
      inline: "text-inherit underline hover:no-underline underline-offset-4",
      pill: "text-md px-6 py-4 rounded-[32px] border border-border text-center leading-none whitespace-nowrap",
      icon: "h-10 w-10 p-0 rounded-full border border-gray-400 bg-background text-inherit hover:bg-accent hover:text-accent-foreground",
      menuPill: "text-md p-5 rounded-[32px] border text-center leading-none whitespace-nowrap hover:underline",
      pageLink: "text-md h-[64px] px-5 underline decoration-transparent underline-offset-[16px] decoration-4 whitespace-nowrap",
      none: ""
    },
    accent: {
      default: "",
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground"
    },
    width: {
      default: "",
      full: "w-full",
      truncate: "truncate"
    },
    // Keep active variants empty; compoundVariants scope pageLink-only active styles
    // so default active=false does not leak hover decoration to other link variants.
    active: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    {
      variant: "pageLink",
      active: !0,
      class: "decoration-primary"
    },
    {
      variant: "pageLink",
      active: !1,
      class: "hover:decoration-gray-400"
    }
  ],
  defaultVariants: {
    variant: "default",
    width: "default",
    active: !1,
    accent: "default"
  }
}), v = e.forwardRef(
  ({ children: n, variant: t, width: a, active: i, accent: o, spacing: d, ...l }, c) => {
    const { className: x, ...s } = l;
    return e.Children.map(n, (r) => e.isValidElement(r) ? e.cloneElement(r, {
      ...s,
      ref: c,
      className: f(
        m({ variant: t, width: a, active: i, accent: o }),
        p(d)
      )
    }) : r);
  }
);
v.displayName = "NavLink";
export {
  v as N,
  m as l
};
